//Settings
import UserBeta from "@/views/Maintenance/UserBeta.vue";
import Withholdings from "@/views/Maintenance/Withholdings.vue";

import Applicants from "@/views/Maintenance/Applicants.vue";
import DepartmentsAccount from "@/views/Maintenance/DepartmentsAccount.vue";
import Boxes from "@/views/Maintenance/Boxes.vue";
import Calendar from "@/views/Maintenance/Calendar.vue";
import AccountingYearClosing from "@/views/Maintenance/AccountingYearClosing.vue";
import Modules from "@/views/Maintenance/Modules.vue";
import AdjustmentReasons from "@/views/Maintenance/AdjustmentReasons.vue";
import PayrollProvisions from "@/views/Maintenance/PayrollProvisions.vue";


import BussinesUnit from "@/views/Maintenance/BussinesUnit.vue";
import ChangeMoney from "@/views/Maintenance/ChangeMoney.vue";
import GroupMoney from "@/views/Maintenance/GroupMoney.vue";
import Maintenance from "@/views/Maintenance/Maintenance.vue"
import CategoriesDGII from "@/views/Maintenance/CategoriesDGII.vue"
import CategoriesAccountig from "@/views/Maintenance/CategoriesAccountig.vue"
import Deductions from "@/views/Maintenance/Deductions.vue"
import Accurals from "@/views/Maintenance/Accurals.vue"
import VouchersVue from "@/views/Maintenance/Vouchers.vue";
import Itbis from "@/views/Maintenance/Itbis.vue";
import Departments from "@/views/Maintenance/Departments.vue";
import Locations from "@/views/Maintenance/Locations.vue";
import CustomerType from "@/views/Maintenance/CustomerType.vue";
import UserProfiles from "@/views/Maintenance/UserProfiles.vue";
import SupplierType from "@/views/Maintenance/SupplierType.vue";
import Projects from "@/views/Projects/Projects.vue";

import AccountsSettings from "@/views/Maintenance/AccountsSettings.vue"
const maintenance = {
  path: "/maintenance",
  name: "Maintenance",
  component: Maintenance,
  meta: {
    code: "SYSFC"
  },
  children: [
    {
      path: "locations",
      name: "Locations",
      component: Locations,
      meta: {
        code: "SYSFC"
      },
    },


    {
      path: "customer_type",
      name: "CustomerType",
      component: CustomerType,
      meta: {
        LOGGED: true,
      },
    },
    {
      path: "supplier_type",
      name: "SupplierType",
      component: SupplierType,
      meta: {
        code: "SYSFC"
      },
    },


    {
      path: "deductions",
      name: "Deductions",
      component: Deductions,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "departments",
      name: "Departments",
      component: Departments,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "accurals",
      name: "Accurals",
      component: Accurals,
      meta: {
        code: "SYSFC"
      },
    },

    {
      path: "itbis",
      name: "Itbis",
      component: Itbis,
      meta: {
        code: "SYSFC"
      },
    },

    {
      path: "bussines_unit",
      name: "BussinesUnit",
      component: BussinesUnit,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "user_profiles",
      name: "UserProfiles",
      component: UserProfiles,
      meta: {
        code: "SYSFC"
      },
    },

    {
      path: "accounts_settings",
      name: "AccountsSettings",
      component: AccountsSettings,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "exchange_money",
      name: "ChangeMoney",
      component: ChangeMoney,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "categories_dgii",
      name: "CategoriesDGII",
      component: CategoriesDGII,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "projects",
      name: "Projects",
      component: Projects,
      meta: {
        code: "CON-24"
      },
    },
    {
      path: "categories_accountig",
      name: "CategoriesAccountig",
      component: CategoriesAccountig,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "group_money",
      name: "GroupMoney",
      component: GroupMoney,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "user",
      name: "User",
      component: UserBeta,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "withholdings",
      name: "Withholdings",
      component: Withholdings,
      meta: {
        code: "SYSFC"
      },
    },

    {
      path: "applicants",
      name: "Applicants",
      component: Applicants,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "departments_account",
      name: "DepartmentsAccount",
      component: DepartmentsAccount,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "voucher_types",
      name: "VouchersVue",
      component: VouchersVue,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "boxes",
      name: "Boxes",
      component: Boxes,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "Calendar",
      name: "Calendar",
      component: Calendar,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "AccountingYearClosing",
      name: "AccountingYearClosing",
      component: AccountingYearClosing,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "Modules",
      name: "Modules",
      component: Modules,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "AdjustmentReasons",
      name: "AdjustmentReasons",
      component: AdjustmentReasons,
      meta: {
        code: "SYSFC"
      },
    },
    {
      path: "PayrollProvisions",
      name: "PayrollProvisions",
      component: PayrollProvisions,
      meta: {
        code: "SYSFC"
      },
    },
  ],
}
export default maintenance


